import { useUiStore } from '@/lib/stores/ui';
import { useWaveform } from '@/lib/hooks/useWaveform';

export function AgentPanel() {
  const { agentActive } = useUiStore();
  const { canvasRef } = useWaveform({ amp: 0.36, grid: false });

  return (
    <div style={{
      background: 'linear-gradient(168deg,#241F1A,#19150F)',
      border: '1px solid var(--app-line2)',
      borderRadius: 'var(--radius-md)',
      padding: '1.25rem',
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.8rem', fontWeight: 540, color: '#fff' }}>
          <span style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: agentActive ? '#4ADE80' : '#79716B',
            boxShadow: agentActive ? '0 0 8px rgba(74,222,128,0.6)' : 'none',
          }} />
          Agent aktiven
        </span>
        <span className="pill pill--copper">v živo</span>
      </div>

      {/* Waveform canvas */}
      <canvas
        ref={canvasRef}
        style={{ width: '100%', height: '56px', display: 'block', margin: '0.5rem 0 1rem' }}
      />

      {/* Stat rows */}
      {([
        ['Sprejetih danes',         '7 / 7'],
        ['Povp. dolžina',           '1:24'],
        ['Pretvorjenih v ponudbo',  '57 %'],
      ] as const).map(([k, v]) => (
        <div key={k} style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0.6rem 0',
          borderTop: '1px solid var(--app-line)',
          fontSize: '0.82rem',
        }}>
          <span style={{ color: 'var(--app-muted)' }}>{k}</span>
          <span style={{ color: '#fff', fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums' }}>{v}</span>
        </div>
      ))}
    </div>
  );
}
